import {CreateAccessor, GetDocs, GetDoc} from "mobx-graphlink";
import {Bundle} from "./bundles/@Bundle";

export const GetBundles = CreateAccessor((): Bundle[]=>{
	return GetDocs({}, a=>a.bundles).map(a=>a?.Cast(Bundle));
});
export const GetBundle = CreateAccessor((id: string|n): Bundle|n=>{
	return GetDoc({}, a=>a.bundles.get(id!))?.Cast(Bundle);
});